// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import {oculus_img_url} from '../../../../hola/pub/ui/oculus_img_url';
import {Lottie} from '../../../../shared/ui/lottie';

import styles from './uptime.module.less';

export const Uptime = ()=>{
    return <p className={styles.uptime}>
      <Lottie autoplay loop width="20px" height="14px"
        src={oculus_img_url('animation/uptime.json')}/>
      <span>Uptime: <b>99.9%</b></span>
    </p>;
};
